import React from 'react';
import PropTypes from 'prop-types';
import { areEqual } from 'react-window';

const ReactWindowRow = ({ index, style, data }) => {
    return <div style={style}>{data[index]}</div>;
};

ReactWindowRow.propTypes = {
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired, //eslint-disable-line react/forbid-prop-types
    data: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default React.memo(ReactWindowRow, areEqual);
